module.exports = __webpack_public_path__ + "img/0Q3A5061_P_L_Black_MockedUp.994aa1da.jpg";